/** @format */

import React from "react";
import Layout from "./Layout";

const OurService = () => {
  return (
    <Layout>
      <div className=" pt-50 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  Our Services
                </h6>
                <h1 className="section-title">Our Core Services</h1>
              </div>
            </div>
          </div>
          <div className="row  justify-content-center">
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="fas fa-laptop-medical"></i>
                  </span>
                  {/* <img src="img/icons/icon-img/21.png" alt="#"> */}
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <a>Simulator Training Services</a>
                  </h3>
                  <p>
                    Elevate the capabilities of medical professionals through
                    our advanced simulator training services.
                  </p>
                  {/* <a class="ltn__service-btn" >Find A Home <i class="flaticon-right-arrow"></i></a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="fas fa-truck"></i>
                  </span>
                  {/* <img src="img/icons/icon-img/21.png" alt="#"> */}
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <a>Logistics and Delivery</a>
                  </h3>
                  <p>
                    Highlight efficient logistics and timely delivery services
                    to ensure hospitals receive their supplies when they need
                    them.
                  </p>
                  {/* <a class="ltn__service-btn" >Find A Home <i class="flaticon-right-arrow"></i></a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="fas fa-user-md"></i>
                  </span>
                  {/* <img src="img/icons/icon-img/21.png" alt="#"> */}
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <a>Product Training</a>
                  </h3>
                  <p>
                    Offer training sessions for hospital staff on how to use new
                    equipment properly and efficiently.
                  </p>
                  {/* <a class="ltn__service-btn" >Find A Home <i class="flaticon-right-arrow"></i></a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="far fa-check-circle"></i>
                  </span>
                  {/* <img src="img/icons/icon-img/21.png" alt="#"> */}
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <a>Quality Assurance</a>
                  </h3>
                  <p>
                    We Provide FDA and ISO-certified products, ensuring
                    hospitals receive high-quality, safe, and reliable supplies.
                  </p>
                  {/* <a class="ltn__service-btn" >Find A Home <i class="flaticon-right-arrow"></i></a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="fas fa-people-carry"></i>
                  </span>
                  {/* <img src="img/icons/icon-img/21.png" alt="#"> */}
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <a>Bulk Ordering</a>
                  </h3>
                  <p>
                    We aslo Provide bulk ordering options, allowing hospitals to
                    manage their inventory effectively.
                  </p>
                  {/* <a class="ltn__service-btn" >Find A Home <i class="flaticon-right-arrow"></i></a> */}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 col-12">
              <div className="ltn__feature-item ltn__feature-item-6 text-center bg-white  box-shadow-1">
                <div className="ltn__feature-icon">
                  <span>
                    <i className="fas fa-phone-alt"></i>
                  </span>
                  {/* <img src="img/icons/icon-img/21.png" alt="#"> */}
                </div>
                <div className="ltn__feature-info">
                  <h3>
                    <a>Technical Support</a>
                  </h3>
                  <p>
                    We offer technical assistance and training for hospitals to
                    effectively use and maintain the equipment.
                  </p>
                  {/* <a class="ltn__service-btn" >Find A Home <i class="flaticon-right-arrow"></i></a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default OurService;
